import React, { Fragment } from "react";
import { Row, Card, CardBody, CardTitle } from "reactstrap";

import IntlMessages from "Util/IntlMessages";

import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";

function social() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.social" />}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12">
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.social" />
                </CardTitle>
                <button className="btn btn-android mr-2 mb-2">
                  <i className="fab fa-android" /> Android
                </button>
                <button className="btn btn-bitcoin mr-2 mb-2">
                  <i className="fab fa-bitcoin" /> Bitcoin
                </button>
                <button className="btn btn-bitbucket mr-2 mb-2">
                  <i className="fab fa-bitbucket" /> Bitbucket
                </button>
                <button className="btn btn-dribbble mb-2 mr-2">
                  <i className="fab fa-dribbble" /> Dribbble
                </button>
                <button className="btn btn-dropbox mb-2 mr-2">
                  <i className="fab fa-dropbox" /> Dropbox
                </button>
                <button className="btn btn-facebook mb-2 mr-2">
                  <i className="fab fa-facebook" /> Facebook
                </button>
                <button className="btn btn-flickr mb-2 mr-2">
                  <i className="fab fa-flickr" /> Flickr
                </button>
                <button className="btn btn-foursquare mb-2 mr-2">
                  <i className="fab fa-foursquare" /> Foursquare
                </button>
                <button className="btn btn-googleplus mb-2 mr-2">
                  <i className="fab fa-google-plus" /> Google+
                </button>
                <button className="btn btn-html5 mb-2 mr-2">
                  <i className="fab fa-html5" /> HTML5
                </button>
                <button className="btn btn-instagram mb-2 mr-2">
                  <i className="fab fa-instagram" /> Instagram
                </button>
                <button className="btn btn-linkedin mb-2 mr-2">
                  <i className="fab fa-linkedin" /> LinkedIn
                </button>
                <button className="btn btn-pinterest mb-2 mr-2">
                  <i className="fab fa-pinterest" /> Pinterest
                </button>
                <button className="btn btn-rss mb-2 mr-2">
                  <i className="fab fa-rss" /> RSS
                </button>
                <button className="btn btn-skype mb-2 mr-2">
                  <i className="fab fa-skype" /> Skype
                </button>
                <button className="btn btn-stackoverflow mb-2 mr-2">
                  <i className="fab fa-stack-overflow" /> StackOverflow
                </button>
                <button className="btn btn-tumblr mb-2 mr-2">
                  <i className="fab fa-tumblr" /> Tumblr
                </button>
                <button className="btn btn-twitter mb-2 mr-2">
                  <i className="fab fa-twitter" /> Twitter
                </button>
                <button className="btn btn-vk mb-2 mr-2">
                  <i className="fab fa-vk" /> VK
                </button>
                <button className="btn btn-weibo mb-2 mr-2">
                  <i className="fab fa-weibo" /> Weibo
                </button>
                <button className="btn btn-windows mb-2 mr-2">
                  <i className="fab fa-windows" /> Windows
                </button>
                <button className="btn btn-xing mb-2 mr-2">
                  <i className="fab fa-xing" /> Xing
                </button>
                <button className="btn btn-youtube mb-2 mr-2">
                  <i className="fab fa-youtube" /> YouTube
                </button>
              </CardBody>
            </Card>

            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.more-social" />
                </CardTitle>
                <button className="btn btn-appnet mr-2 mb-2">Appnet</button>

                <button className="btn mr-2 mb-2 btn-blogger">blogger</button>

                <button className="btn mr-2 mb-2 btn-bitbucket">
                  bitbucket
                </button>

                <button className="btn mr-2 mb-2 btn-dribbble">dribbble</button>

                <button className="btn mr-2 mb-2 btn-facebook">facebook</button>

                <button className="btn mr-2 mb-2 btn-flattr">flattr</button>

                <button className="btn mr-2 mb-2 btn-flickr">flickr</button>

                <button className="btn mr-2 mb-2 btn-foursquare">
                  foursquare
                </button>

                <button className="btn mr-2 mb-2 btn-github">github</button>

                <button className="btn mr-2 mb-2 btn-googleplus">
                  googleplus
                </button>

                <button className="btn mr-2 mb-2 btn-gowalla">gowalla</button>

                <button className="btn mr-2 mb-2 btn-instagram">
                  instagram
                </button>

                <button className="btn mr-2 mb-2 btn-klout">klout</button>

                <button className="btn mr-2 mb-2 btn-lastfm">lastfm</button>

                <button className="btn mr-2 mb-2 btn-linkedin">linkedin</button>

                <button className="btn mr-2 mb-2 btn-meetup">meetup</button>

                <button className="btn mr-2 mb-2 btn-myspace">myspace</button>

                <button className="btn mr-2 mb-2 btn-pinterest">
                  pinterest
                </button>

                <button className="btn mr-2 mb-2 btn-quora">quora</button>

                <button className="btn mr-2 mb-2 btn-reddit">reddit</button>

                <button className="btn mr-2 mb-2 btn-plurk">plurk</button>

                <button className="btn mr-2 mb-2 btn-smashing">smashing</button>

                <button className="btn mr-2 mb-2 btn-soundcloud">
                  soundcloud
                </button>

                <button className="btn mr-2 mb-2 btn-stackoverflow">
                  stackoverflow
                </button>

                <button className="btn mr-2 mb-2 btn-tumblr">tumblr</button>

                <button className="btn mr-2 mb-2 btn-twitter">twitter</button>

                <button className="btn mr-2 mb-2 btn-viadeo">viadeo</button>

                <button className="btn mr-2 mb-2 btn-vimeo">vimeo</button>

                <button className="btn mr-2 mb-2 btn-vk">vk</button>

                <button className="btn mr-2 mb-2 btn-weibo">weibo</button>

                <button className="btn mr-2 mb-2 btn-xing">xing</button>

                <button className="btn mr-2 mb-2 btn-youtube">youtube</button>
              </CardBody>
            </Card>

            {/*  Buttons without icons */}
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.services" />
                </CardTitle>

                <button className="btn mr-2 mb-2 btn-amazon">amazon</button>

                <button className="btn mr-2 mb-2 btn-delicious">
                  delicious
                </button>

                <button className="btn mr-2 mb-2 btn-digg">digg</button>

                <button className="btn mr-2 mb-2 btn-disqus">disqus</button>

                <button className="btn mr-2 mb-2 btn-eventbrite">
                  eventbrite
                </button>

                <button className="btn mr-2 mb-2 btn-eventful">eventful</button>

                <button className="btn mr-2 mb-2 btn-intensedebate">
                  intensedebate
                </button>

                <button className="btn mr-2 mb-2 btn-lanyrd">lanyrd</button>

                <button className="btn mr-2 mb-2 btn-pinboard">pinboard</button>

                <button className="btn mr-2 mb-2 btn-songkick">songkick</button>

                <button className="btn mr-2 mb-2 btn-stumbleupon">
                  stumbleupon
                </button>

                <button className="btn mr-2 mb-2 btn-gmail">gmail</button>

                <button className="btn mr-2 mb-2 btn-google">google</button>

                <button className="btn mr-2 mb-2 btn-evernote">evernote</button>

                <button className="btn mr-2 mb-2 btn-grooveshark">
                  grooveshark
                </button>

                <button className="btn mr-2 mb-2 btn-instapaper">
                  instapaper
                </button>

                <button className="btn mr-2 mb-2 btn-itunes">itunes</button>

                <button className="btn mr-2 mb-2 btn-opentable">
                  opentable
                </button>

                <button className="btn mr-2 mb-2 btn-logmein">logmein</button>

                <button className="btn mr-2 mb-2 btn-ninetyninedesigns">
                  ninetyninedesigns
                </button>

                <button className="btn mr-2 mb-2 btn-paypal">paypal</button>

                <button className="btn mr-2 mb-2 btn-pocket">pocket</button>

                <button className="btn mr-2 mb-2 btn-scribd">scribd</button>

                <button className="btn mr-2 mb-2 btn-spotify">spotify</button>

                <button className="btn mr-2 mb-2 btn-statusnet">
                  statusnet
                </button>

                <button className="btn mr-2 mb-2 btn-stripe">stripe</button>

                <button className="btn mr-2 mb-2 btn-yahoo">yahoo</button>

                <button className="btn mr-2 mb-2 btn-yelp">yelp</button>
              </CardBody>
            </Card>

            {/* Content Sites */}
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.content-sites" />
                </CardTitle>

                <button className="btn mr-2 mb-2 btn-wikipedia">
                  wikipedia
                </button>
                <button className="btn mr-2 mb-2 btn-wordpress">
                  wordpress
                </button>
                <button className="btn mr-2 mb-2 btn-ycombinator">
                  ycombinator
                </button>
              </CardBody>
            </Card>
            {/* Store Buttons */}

            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.store-button" />
                </CardTitle>

                <button className="btn mr-2 mb-2 btn-android">android</button>

                <button className="btn mr-2 mb-2 btn-appstore">appstore</button>

                <button className="btn mr-2 mb-2 btn-googleplay">
                  googleplay
                </button>

                <button className="btn mr-2 mb-2 btn-macstore">macstore</button>
              </CardBody>
            </Card>

            {/* Games Buttons */}
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.gaming-sites" />
                </CardTitle>

                <button className="btn mr-2 mb-2 btn-csgo">csgo</button>

                <button className="btn mr-2 mb-2 btn-dota2">dota2</button>

                <button className="btn mr-2 mb-2 btn-gm">gm</button>

                <button className="btn mr-2 mb-2 btn-lol">lol</button>

                <button className="btn mr-2 mb-2 btn-minecraft">
                  minecraft
                </button>

                <button className="btn mr-2 mb-2 btn-tf2">tf2</button>

                <button className="btn mr-2 mb-2 btn-quake">quake</button>

                <button className="btn mr-2 mb-2 btn-wot">wot</button>
              </CardBody>
            </Card>

            {/* Misc Buttons */}
            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.misc-buttons" />
                </CardTitle>

                <button className="btn mr-2 mb-2 btn-bitcoin">bitcoin</button>

                <button className="btn mr-2 mb-2 btn-cloudapp">cloudapp</button>

                <button className="btn mr-2 mb-2 btn-creativecommons">
                  creativecommons
                </button>

                <button className="btn mr-2 mb-2 btn-dropbox">dropbox</button>

                <button className="btn mr-2 mb-2 btn-html5">html5</button>

                <button className="btn mr-2 mb-2 btn-ie">ie</button>

                <button className="btn mr-2 mb-2 btn-podcast">podcast</button>

                <button className="btn mr-2 mb-2 btn-rss">rss</button>

                <button className="btn mr-2 mb-2 btn-skype">skype</button>

                <button className="btn mr-2 mb-2 btn-steam">steam</button>

                <button className="btn mr-2 mb-2 btn-windows">windows</button>
              </CardBody>
            </Card>

            <Card className="mb-4">
              <CardBody>
                <CardTitle>
                  <IntlMessages id="button.rounded-buttons" />
                </CardTitle>
                <button className="btn btn-android mr-2 mb-2 rounded">
                  <i className="fab fa-android" /> Android
                </button>
                <button className="btn btn-bitcoin mr-2 mb-2 rounded">
                  <i className="fab fa-bitcoin" /> Bitcoin
                </button>
                <button className="btn btn-bitbucket mr-2 mb-2 rounded">
                  <i className="fab fa-bitbucket" /> Bitbucket
                </button>
                <button className="btn btn-dribbble mb-2 mr-2 rounded">
                  <i className="fab fa-dribbble" /> Dribbble
                </button>
                <button className="btn btn-dropbox mb-2 mr-2 rounded">
                  <i className="fab fa-dropbox" /> Dropbox
                </button>
                <button className="btn btn-facebook mb-2 mr-2 rounded">
                  <i className="fab fa-facebook" /> Facebook
                </button>
                <button className="btn btn-flickr mb-2 mr-2 rounded">
                  <i className="fab fa-flickr" /> Flickr
                </button>
                <button className="btn btn-foursquare mb-2 mr-2 rounded">
                  <i className="fab fa-foursquare" /> Foursquare
                </button>
                <button className="btn btn-googleplus mb-2 mr-2 rounded">
                  <i className="fab fa-google-plus" /> Google+
                </button>
                <button className="btn btn-html5 mb-2 mr-2 rounded">
                  <i className="fab fa-html5" /> HTML5
                </button>
                <button className="btn btn-instagram mb-2 mr-2 rounded">
                  <i className="fab fa-instagram" /> Instagram
                </button>
                <button className="btn btn-linkedin mb-2 mr-2 rounded">
                  <i className="fab fa-linkedin" /> LinkedIn
                </button>
                <button className="btn btn-pinterest mb-2 mr-2 rounded">
                  <i className="fab fa-pinterest" /> Pinterest
                </button>
                <button className="btn btn-rss mb-2 mr-2 rounded">
                  <i className="fab fa-rss" /> RSS
                </button>
                <button className="btn btn-skype mb-2 mr-2 rounded">
                  <i className="fab fa-skype" /> Skype
                </button>
                <button className="btn btn-stackoverflow mb-2 mr-2 rounded">
                  <i className="fab fa-stack-overflow" /> StackOverflow
                </button>
                <button className="btn btn-tumblr mb-2 mr-2 rounded">
                  <i className="fab fa-tumblr" /> Tumblr
                </button>
                <button className="btn btn-twitter mb-2 mr-2 rounded">
                  <i className="fab fa-twitter" /> Twitter
                </button>
                <button className="btn btn-vk mb-2 mr-2 rounded">
                  <i className="fab fa-vk" /> VK
                </button>
                <button className="btn btn-weibo mb-2 mr-2 rounded">
                  <i className="fab fa-weibo" /> Weibo
                </button>
                <button className="btn btn-windows mb-2 mr-2 rounded">
                  <i className="fab fa-windows" /> Windows
                </button>
                <button className="btn btn-xing mb-2 mr-2 rounded">
                  <i className="fab fa-xing" /> Xing
                </button>
                <button className="btn btn-youtube mb-2 mr-2 rounded">
                  <i className="fab fa-youtube" /> YouTube
                </button>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
}

export default social;
